import { Manifest } from '@/types';
import { createContext, FunctionalComponent } from 'preact';
import { useContext } from 'preact/hooks';

export const ManifestContext = createContext<Manifest>(undefined!);

export const useManifest = (): Manifest => {
  return useContext(ManifestContext);
};

export const ManifestProvider: FunctionalComponent<{
  manifest: Manifest;
}> = ({ manifest, children }) => {
  return (
    <ManifestContext.Provider value={manifest}>
      {children}
    </ManifestContext.Provider>
  );
};
